<template>
  <EditorV2 v-if="tbIsNew && ['wirelessDesc'].includes(this.props.name)" :props="props"></EditorV2>
  <div v-else class="editor">
    <template v-if="['desc'].includes(this.props.name)">
      <div class="tips ft-12">
        由于淘宝商品接口改造，该字段即将下线，商品详情请填写【旺铺无线详情描述】字段
        <div>新版商品详情不再区分电脑端和手机端，上传【旺铺无线详情描述】字段后，将分别在电脑端和手机端展示</div>
        <!-- 为了进一步提升消费者体验，平台新增
        <el-link
          href="https://helpcenter.taobao.com/servicehall/knowledge_detail?kwdContentId=445704076455375872&searchKey=9fab549735554ba89d1659d54a7a6baf1&source=6&spm=service_hall.25034502.shcSearchResult_kuph4mbg.445704076455375872&hcSessionId=3-1281-30bd039c-6433-4c54-ac29-f5719e3c4ca9"
          target="_blank"
          >《商品详情页主图设计规范》</el-link
        >， 请参考该规范设计商品主图 -->
      </div>
    </template>
    <el-button
      v-if="isWirelessDesc"
      style="margin-bottom: 10px;"
      @click="importPCdesc">导入电脑端描述</el-button>
    <el-button
      v-if="showImportImages"
      style="margin-bottom: 10px;"
      @click="importImages">导入电脑端宝贝图片</el-button>
    <el-button
      v-if="showPictureZone"
      style="margin-bottom: 10px;"
      @click="openPictureZone">从素材空间上传</el-button>
    <Editor
      :id="key"
      :ref="key"
      :value="tbForm[key]"
      :menus="menus"
      :extraAttr="extraAttr"
      @change="onChange"
      @fullScreenChange="editorFullScreenChange"
    />
    <ChoosePictrueZone v-show="choosePictrueZoneVisible" ref="choosePictrueZoneRef"/>
    <ChooseNewPictrueZone v-show="chooseNewPictrueZoneVisible" :appendToBody="true" ref="chooseNewPictrueZoneRef"/>
  </div>
</template>

<script>
import {editor_mixin} from '@/components/Editor/index.js'
import storeMixins from '../store-mixins'
import EditorV2 from './indexV2.vue'
import ChoosePictrueZone from "@/components/Uploads/ChoosePictrueZone.vue";
import ChooseNewPictrueZone from "@/components/Uploads/ChooseNewPictrueZone.vue";
import { mapGetters } from 'vuex'
export default {
  components: {
    EditorV2,
    ChoosePictrueZone,
    ChooseNewPictrueZone,
  },
  mixins: [storeMixins, editor_mixin],
  props: ["props"],
  inject: ["tbFormVm", { injectedOuterId: { default: () => '', from: 'outerId' } }],
  data(){
    return {
      choosePictrueZoneVisible: false,
      chooseNewPictrueZoneVisible: false
    }
  },
  computed: {
    ...mapGetters(['tbIsNew']),
    key() {
      return this.props.name
    },
    extraAttr() {
      return this.props.extraAttr
    },
    isWirelessDesc() {
      return this.props.name === 'wirelessDesc'
    },
    showImportImages() {
      return ['wirelessDesc', 'desc'].includes(this.props.name)
    },
    showPictureZone(){
      return ['wirelessDesc', 'desc'].includes(this.props.name)
    },
    menus() {
      // 手机端只允许上传图片
      return this.isWirelessDesc ? ["image"] : []
    }
  },
  watch: {
    editorFormItenClass: {
      immediate: true,
      handler(v) {
        if (!this.$el || !this.$el.parentNode) {
          return ;
        }
        this.fixFullScreenStyle()
      }
    }
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v
      this.updateTbForm(newFormFields)
    },
    importPCdesc() {
      this.onChange(this.tbForm.desc)
      // 初始化好的编辑器需要调用内置方法更新文本
      this.$nextTick(() => {
        this.$refs[this.key].init_text()
      })
    },
    // 倒入宝贝详情图
    importImages() {
      let images = this.tbForm.images
      if (!images || !images.length) {
        return this.$message.error('电脑端宝贝图片不存在')
      }
      this.$refs[this.key].addImages(images);
      this.$message.success('导入电脑端宝贝图片成功');
    },
    // 修复富文本全屏的及非全屏层级问题
    fixFullScreenStyle() {
      let v = this.editorFormItenClass
      if (v[1].nofull) {
        this.$el.parentNode.style.zIndex = 1
      } else {
        this.$el.parentNode.style.zIndex = ""
      }
    },
    openPictureZone() {
      const that = this;
      this.chooseNewPictrueZoneVisible = true
      this.$nextTick(() => {
        this.$refs.chooseNewPictrueZoneRef.method_open({
          isSingle: false,
          productCode: that.tbFormVm.form.baseItemId,
          outerId: this.injectedOuterId,
          folderId: localStorage.getItem('km_picture_folder_id') || '',
          okFn(urlList) {
            let urls = urlList.map(item => item.url)
            that.$refs[that.key].addImages(urls);
          },
        })
      })
    },
  },
  mounted() {
    this.fixFullScreenStyle()
  },
  beforeDestroy() {
    this.choosePictrueZoneVisible = false
    this.chooseNewPictrueZoneVisible = false
  }
}
</script>

<style lang="scss">
#editor-desc, #editor-wirelessDesc {
  .w-e-text {
    text-align: center;
    img {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>